import { API } from '.'

export const upsertExpert = payload => {
  return API.post('upsertexpert', payload)
}

export const getExpert = payload => {
  return API.post('getexpert', payload)
}
